import React from 'react';
import moment from 'moment';
import {any, number, bool, func, oneOf, string} from 'prop-types';
import {Input, Checkbox, Label} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import {Redirect} from 'react-router-dom';
import BasicModal from 'components/common/BasicModal';
import {validationRules} from 'components/forms/validationRules';
import {
  isNoU,
  zeroPad,
  addThousandsCommas,
  SitesByLanguage,
  CurrenciesByLanguage,
  CurrencyPrefixesByLanguage
} from 'utils/DBUtils';

const validationParams = {
  min: 1,
  max: 100 * 1000
};

export default class CreateStoreEscrowModal extends React.Component {
  static propTypes = {
    lang: oneOf(Object.keys(CurrencyPrefixesByLanguage)),
    year: number.isRequired,
    month: number,
    defaultValue: number,
    isOpen: bool,
    isCreating: bool,
    createdStoreEscrow: bool,
    onClose: func.isRequired,
    onSubmit: func.isRequired,
    apiError: string
  };

  static defaultProps = {
    lang: 'en-US',
    defaultValue: 5700
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen && !this.props.isOpen) {
      // reset from initial state each time this modal opens, so as not to show stale values/validations.
      this.setState(this.initialState);
    }

    if (nextProps.apiError !== this.state.apiError) {
      this.setState({apiError: nextProps.apiError});
    }
  }

  get initialState() {
    return {
      value: this.props.defaultValue,
      copyCurrentMonth: true,
      validationError: null,
      apiError: null
    };
  }

  handleValueChange = (event, {value}) => {
    value = Number(value);

    const validationError = ['NumberFormat', 'InclusiveRange'].find(rule => {
      const isValid = validationRules[rule](value, validationParams);
      return !isValid;
    });

    this.setState({
      value,
      validationError: validationError ? 'invalid_escrow_budget' : null,
      apiError: this.initialState.apiError // clear API error-related messaging when user adjusts inputs
    });
  };

  handleCheckboxChange = (event, {checked}) => {
    this.setState({
      copyCurrentMonth: checked,
      apiError: this.initialState.apiError
    });
  };

  get actions() {
    return [
      {
        displayType: 'menu-item',
        action: this.props.onClose,
        isDisabled: this.props.isCreating,
        label: <FormattedMessage id='rewardsStore.modal.createStore.cancel' />
      },
      {
        displayType: 'button',
        primaryCheck: true,
        action: () => this.props.onSubmit(this.state.value, this.state.copyCurrentMonth),
        loading: this.props.isCreating,
        label: <FormattedMessage id='rewardsStore.modal.createStore.submit' />,
      }
    ];
  }

  render() {
    if (isNoU(this.props.month)) {
      return null;
    }

    if (this.props.createdStoreEscrow) {
      const newStoreEscrowRoute = [
        '/rewards',
        this.props.lang,
        this.props.year,
        zeroPad(this.props.month + 1, 2)
      ].join('/');

      return <Redirect to={newStoreEscrowRoute} />;
    }

    const startDate = moment()
      .date(1)
      .month(this.props.month)
      .year(this.props.year);

    const hasError = this.state.validationError || this.state.apiError;

    return (
      <BasicModal
        header={(
          <FormattedMessage
            id='rewardsStore.modal.createStore.header'
            values={{
              site: SitesByLanguage[this.props.lang],
              month: startDate.format('MMMM'),
              year: startDate.format('YYYY')
            }} />
        )}
        specialType='primary-modal fadeInUp animResponse create-store-modal'
        dimmer='inverted'
        modalSize='tiny'
        open={this.props.isOpen}
        closeOnDimmerClick={true}
        onClose={this.props.onClose}
        actions={this.actions}>
        <div>
          <FormattedMessage
            id='rewardsStore.modal.createStore.message'
            values={{startDate: startDate.format('MMMM D, YYYY')}} />
        </div>
        <div className='create-store-escrow-budget-label-container'>
          <FormattedMessage id='rewardsStore.modal.createStore.label' />
        </div>
        <div className='field-with-inline-label'>
          <Input
            type='number'
            error={hasError}
            value={this.state.value || ''}
            onChange={this.handleValueChange}
            label={CurrencyPrefixesByLanguage[this.props.lang]} />
        </div>
        {this.state.validationError && (
          <Label basic className='db-error-label create-store-escrow-validation-error'>
            <FormattedMessage
              id={`errors.validation.${this.state.validationError}`}
              values={{
                currency: CurrenciesByLanguage[this.props.lang],
                min: validationParams.min,
                max: addThousandsCommas(validationParams.max)
              }} />
          </Label>
        )}
        <div className='create-store-escrow-copy-checkbox-container'>
          <Checkbox
            label={(
              <label>
                <FormattedMessage
                  id='rewardsStore.modal.createStore.checkbox'
                  values={{month: moment().format('MMMM')}} />
              </label>
            )}
            onChange={this.handleCheckboxChange}
            defaultChecked={true} />
        </div>
        {this.state.apiError && (
          <Label basic className='db-error-label create-store-escrow-api-error'>
            <FormattedMessage id={`errors.${this.props.apiError}`} />
          </Label>
        )}
      </BasicModal>
    );
  }
};



// WEBPACK FOOTER //
// ./public/pages/Rewards/RewardsDashboard/CreateStoreEscrowModal.jsx